/**
 * Converts a data URI to an ArrayBuffer containing binary data.
 *
 * This function takes a data URI representing an image and converts it into an ArrayBuffer containing
 * binary data. It extracts the base64-encoded data from the data URI, decodes it into a binary string,
 * and then converts it into a Uint8Array representing the binary data. Finally, it returns the buffer
 * containing the binary data.
 *
 * @param {string} dataURI - The data URI to convert to an ArrayBuffer.
 * @returns {ArrayBuffer} An ArrayBuffer containing the binary data extracted from the data URI.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return dataURIToArrayBuffer;
    }
});
function dataURIToArrayBuffer(dataURI) {
    const base64 = dataURI.split(",")[1];
    const binaryString = window.atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++){
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
